import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="inline-block mb-4">
                <span className="font-heading text-2xl text-background-50">
                  汗汗漫画
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                汗汗漫画网提供韩漫、日漫、国漫等主流漫画类型分类，汇集免费漫画全集、下拉式连续阅读模式，在线看漫画流畅不卡顿，尽享热门漫画大全。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-lg text-background-50 mb-4">漫画分类</h4>
              <ul className="space-y-2">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-lg text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/hanman" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">
                    韩漫
                  </Link>
                </li>
                <li>
                  <Link to="/category/riman" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">
                    日漫
                  </Link>
                </li>
                <li>
                  <Link to="/category/guoman" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">
                    国漫
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-lg text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2 text-sm text-background-400">
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line mt-0.5"></i>
                  <span>contact@hanhancomic.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-customer-service-2-line mt-0.5"></i>
                  <span>在线客服：周一至周日 9:00-21:00</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {currentYear} 汗汗漫画网 - 版权所有 | 韩漫日漫国漫免费漫画全集
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap">服务条款</a>
              <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}